import React, {useState} from 'react';
import { Modal, TextInput } from "@graffer-inc/graffer-ui";

const Main = ({onClose, onExecute}) => {
  const validate = v => v.length >= 11 && v.length <= 13;
  const [trackingNo, setTrackingNo] = useState('');
  return (
    <Modal onClose={onClose}>
      <div className="card" style={{ padding: "20px 30px" }}>
        <article className="message is-warning">
          <div className="message-body">
            <p>こちらの申込のお客様に発送完了メールを送ります。</p>
            <p>メールを送ると、ユーザーのステータスが「発送完了」に変わります。</p>
            <p className="has-text-weight-bold">送られるメールには「追跡番号」が含まれるため、入力ミスがないか必ず 確認して「送信する」ボタンを押してください。</p>
          </div>
        </article>
        <div>
          <TextInput
            type="number"
            value={trackingNo}
            onChange={setTrackingNo}
            validate={validate}
            placeholder="追跡番号"
            errorMessage="追跡番号は半角数字11桁から13桁で入力してください。"
          />
        </div>
        <br/>
        <div className="is-flex">
          <button
            disabled={!validate(trackingNo)}
            onClick={() => onExecute(trackingNo)}
            className="button is-info is-rounded is-fullwidth"
          >
            送信する
          </button>
          <div style={{ padding: "0px 5px" }}></div>
          <button
            onClick={onClose}
            className="button is-text is-rounded is-fullwidth"
          >
            キャンセル
          </button>
        </div>
      </div>
    </Modal>
  );
}

export default Main;